import React, { createContext, useContext, useEffect, useState } from "react";

// Use user context types
import { IUserContextProps } from "./useUserContextTypes";
import { IUser } from "../../components/shared/commonTypes/commonTypes";
import { getApi } from "../../services/apiManager/ApiManager";

// User context initialization
const useUserContext = createContext<IUserContextProps | undefined>(undefined);

// User provider component
export const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<IUser | null>(null);

  // useEffect(() => {
  //   // Simulate an API call or user fetch logic
  //   const fetchUser = async () => {
  //     try {
  //       const response = await getApi("/v1/user/current");
  //       if (response.status) {
  //         const user: IUser = {
  //           name: response.data.name,
  //           role: response.data.roles[0].name,
  //         };
  //         setUser(user);
  //       }
  //     } catch (error) {
  //       // navigate("/authenticate"); // Redirect to login if API call fails
  //     } finally {
  //       // setLoading(false);
  //     } // Replace with actual API call
  //     // setUser(fetchedUser);
  //   };

  //   fetchUser();
  // }, []);

  return (
    <useUserContext.Provider value={{ user, setUser }}>
      {children}
    </useUserContext.Provider>
  );
};

// User user
export const useUser = () => {
  const context = useContext(useUserContext);
  if (!context) throw new Error("useUser must be used within a UserProvider");
  return context;
};
